module.exports = __webpack_public_path__ + "img/CS-Profi13_Overview-Spare_2.50b640da.jpg";